import { ROLES } from '@/constants/roles';
import formatRoutes from '@/helpers/user-redesign/formatRoutes';

const routes = [
  {
    path: '/event/view/:id',
    name: 'event-landing-redesign',
    component: () => import('@/modules/UserEventLanding/views/event-landing.vue'),
    meta: {
      preventLayoutTemplate: true,
      title: 'Страница мероприятия',
    },
  },
];

const noBreadcrumbsRoutes = [
  {
    path: '/event/register/:id',
    name: 'event-register-redesign',
    component: () => import('./views/event-register.vue'),
    meta: {
      title: 'Запись на мероприятие',
      accessList: [ROLES.certificate, ROLES.member, ROLES.guest],
    },
  },
  {
    path: '/event/applications/:id',
    name: 'event-applications-redesign',
    component: () => import('./views/event-applications.vue'),
    meta: {
      title: 'Заявки на мероприятие',
    },
  },
  {
    path: '/event/register/:id/successful',
    name: 'event-register-successful-redesign',
    component: () => import('./views/event-register-successful.vue'),
    meta: {
      preventLayoutTemplate: true,
      title: 'Заявка отправлена',
      accessList: [ROLES.certificate, ROLES.member],
    },
  },
];

export default [...formatRoutes(routes), ...formatRoutes(noBreadcrumbsRoutes, false)];
